<div class="sidebarContainer">
  <div class="sidebar" [ngClass]="{'active':!sideExp}">
    <div class="menubar-icon">
      <li class="nav-item">
        <a class="nav-link">
          <span class="icon" (click)="expandCollaspse()">
            <i class="pi pi-bars"></i>
          </span>
          <span class="menu-txt">Menu</span>
        </a>
      </li>

    </div>

    <nav class="main-nav">
      <ul class="main-menu">
        @if(selectedApps=='audio'){
        <li class="menu-item" routerLink="/main/postcall/fileUpload" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon">
                <i class="fa-solid fa-cloud-arrow-up"></i></span>
              <span class="menu-txt">File Upload</span>
            </div>
          </a>
        </li>
        <li class="menu-item" routerLink="/main/postcall/progress" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa fa-tasks"></i></span>
              <span class="menu-txt">Progress Monitor</span>
            </div>
          </a>
        </li>
        <li class="menu-item" routerLink="/main/postcall/audioRecords" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa fa-file-audio"></i></span>
              <span class="menu-txt">Voice Analytics</span>
            </div>
          </a>
        </li>
        }
        @if(selectedApps=='email'){
        <li class="menu-item" routerLink="/main/email/emailfileUpload" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-cloud-arrow-up"></i></span>
              <span class="menu-txt">File Upload</span>
            </div>
          </a>
        </li>
        <li class="menu-item" routerLink="/main/email/autoEmailRecords" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid  fa-envelope"></i></span>
              <span class="menu-txt">Email Analytics</span>
            </div>
          </a>
        </li>
        }

         @if(selectedApps=='emailAudit'){
           <li class="menu-item" routerLink="/main/emailAudit/emailfileUpload" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-cloud-arrow-up"></i></span>
              <span class="menu-txt">File Upload</span>
            </div>
          </a>
        </li>
        
        <li class="menu-item" routerLink="/main/emailAudit/emailRecords" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid  fa-envelope"></i></span>
              <span class="menu-txt">Email Analytics</span>
            </div>
          </a>
        </li>
        <li class="menu-item" routerLink="/main/emailAudit/emailconfiguration" routerLinkActive="active"
          *ngIf="userDetails?.role === 102">

          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-gears "></i></span>
              <span class="menu-txt">Configuration</span>
            </div>
          </a>

        </li>
        }

        @if(selectedApps=='voiceMail'){
        <li class="menu-item" routerLink="/main/voiceemailfileUpload" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-cloud-arrow-up"></i></span>
              <span class="menu-txt">File Upload</span>
            </div>
          </a>
        </li>
        <li class="menu-item" routerLink="/main/postcall/progress" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa fa-tasks "></i></span>
              <span class="menu-txt">Progress Monitor</span>
            </div>
          </a>
        </li>
        <li class="menu-item" routerLink="/main/voiceMailRecords" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-voicemail"></i></span>
              <span class="menu-txt">Voice Mail Analytics</span>
            </div>
          </a>
        </li>


        }
        @if(selectedApps=='survey'){
        <li class="menu-item" routerLink="/main/surveyRecords" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-square-check "></i></span>
              <span class="menu-txt">Survey Analytics</span>
            </div>
          </a>
        </li>

        }
        @else if(selectedApps=='ivr'){

        <li class="menu-item" routerLink="/main/fileUpload" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-cloud-arrow-up "></i></span>
              <span class="menu-txt">File Upload</span>
            </div>
          </a>
        </li>
        <li class="menu-item" routerLink="/main/postcall/progress" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa fa-tasks "></i></span>
              <span class="menu-txt">Progress Monitor</span>
            </div>
          </a>
        </li>
        <li class="menu-item" routerLink="/main/ivrRecords" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"> <i class="fa-solid fa-square-check "></i></span>
              <span class="menu-txt">IVR Analytics</span>
            </div>
          </a>
        </li>
        }
        @else if(selectedApps=='text'){
        <li class="menu-item" routerLink="/main/textfileUpload" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-cloud-arrow-up "></i></span>
              <span class="menu-txt">File Upload</span>
            </div>
          </a>
        </li>
        <li class="menu-item" routerLink="/main/textRecords" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-file-lines "></i></span>
              <span class="menu-txt">Text Analytics</span>
            </div>
          </a>

        </li>
        }
        @if(selectedApps=='document'){
        <!-- <li class="menu-item" routerLink="/main/document/docfileUpload/0" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-cloud-arrow-up"></i></span>
              <span class="menu-txt">File Upload</span>
            </div>
          </a>
        </li>
        <li class="menu-item" routerLink="/main/document/docRecords" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-file "></i></span>
              <span class="menu-txt">Documents</span>
            </div>
          </a>
        </li> -->
         <li class="menu-item" routerLink="/main/doc-analytics/training" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon">
                <img class="active" src="../../../assets/images/brain-circuit-active.svg" height="35" width="35">
                <img class="inactive" src="../../../assets/images/brain-circuit-inactive.svg" height="35" width="35">
              </span>
              <span class="menu-txt">AI Training</span>
            </div>
          </a>
        </li>
       
        <li class="menu-item" routerLink="/main/doc-analytics/global-search" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="bi bi-globe"></i></span>
              <span class="menu-txt"> Global Q&A</span>
            </div>
          </a>
        </li>
        <!--   <li class="menu-item" routerLink="/main/rfpcontracts/negotiation" routerLinkActive="active" *ngIf="userDetails?.role === 102">
                       <a  class="menu-a" >
                          <div class="menu-txt-hld">
                            <span class="menu-icon"><i class="bi bi-envelope"></i></span> 
                            <span class="menu-txt">Discussion</span>
                          </div>
                       </a>
                </li>
         -->
        <li class="menu-item" routerLink="/main/doc-analytics/feedback" routerLinkActive="active"
          *ngIf="userDetails?.role === 102">

          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="bi bi-chat-right-text"></i></span>
              <span class="menu-txt">Feedback</span>
            </div>
          </a>

        </li>
        }
        @if(selectedApps!='contract' && selectedApps!='rfpcontract' && selectedApps !='infosecurity' && selectedApps !='document' &&
        selectedApps!='email'  && selectedApps!='emailAudit'){
        <li class="menu-item" routerLink="/main/postcall/userManagement" routerLinkActive="active"
          *ngIf="userDetails?.role === 102">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa fa-users"></i></span>
              <span class="menu-txt">User Management</span>
            </div>
          </a>
        </li>
        }
        @if(selectedApps=='email'){
        
        <li class="menu-item" routerLink="/main/email/emailconfiguration" routerLinkActive="active"
          *ngIf="userDetails?.role === 102">

          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-gears "></i></span>
              <span class="menu-txt">Configuration</span>
            </div>
          </a>

        </li>
        }
        @else if(selectedApps=='voiceMail'){
        <!-- <li class="menu-item" routerLink="/main/voiceMailconfiguration" routerLinkActive="active">
          <a  class="menu-a" >
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-gears "></i></span>
              <span class="menu-txt">Voice Mail Configuration</span>
            </div>
          </a>
        </li>   -->
        }@else if(selectedApps=='ivr'){

        } @else if(selectedApps=='text'){
        <li class="menu-item" routerLink="/main/emailconfiguration" routerLinkActive="active"
          *ngIf="userDetails?.role === 102">

          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-gears "></i></span>
              <span class="menu-txt">Configuration</span>
            </div>
          </a>

        </li>
        }
        @else if(selectedApps!='contract' && selectedApps !='rfpcontract' && selectedApps !='infosecurity' && selectedApps !='document'  && selectedApps !='emailAudit'){
        <li class="menu-item" routerLink="/main/postcall/configuration" routerLinkActive="active"
          *ngIf="userDetails?.role === 102">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-gears "></i></span>
              <span class="menu-txt">Configuration</span>
            </div>
          </a>
        </li>
        }
        @if(selectedApps=='contract'){
        <!-- <li class="menu-item" routerLink="/main/contracts/reports" routerLinkActive="active" *ngIf="userDetails?.role === 102">
                       <a  class="menu-a" >
                          <div class="menu-txt-hld">
                           <span class="menu-icon">   <i class="bi bi-bar-chart-line-fill"></i></span>
                            <span class="menu-txt">Reports</span>
                          </div>
                       </a>
                </li> 
           
                <li class="menu-item" routerLink="/main/contracts/createTemplate" routerLinkActive="active" *ngIf="userDetails?.role === 102">
                       <a  class="menu-a" >
                          <div class="menu-txt-hld">
                           <span class="menu-icon"><i class="bi bi-journal-text"></i></span>
                            <span class="menu-txt">Create Template</span>
                          </div>
                       </a>
                </li>
                  <li class="menu-item" routerLink="/main/contracts/createContract" routerLinkActive="active" *ngIf="userDetails?.role === 102">
                       <a  class="menu-a" >
                          <div class="menu-txt-hld">
                            <span class="menu-icon"><i class="bi bi-card-text"></i></span> 
                            <span class="menu-txt">Create Contract</span>
                          </div>
                       </a>
                </li>
                <li class="menu-item" routerLink="/main/contracts/negotiation" routerLinkActive="active" *ngIf="userDetails?.role === 102">
                       <a  class="menu-a" >
                          <div class="menu-txt-hld">
                            <span class="menu-icon"><i class="bi bi-envelope"></i></span> 
                            <span class="menu-txt">Negotiation</span>
                          </div>
                       </a>
                </li>
         
                <li class="menu-item" routerLink="/main/contracts/repository" routerLinkActive="active" *ngIf="userDetails?.role === 102">
                       <a  class="menu-a" >
                          <div class="menu-txt-hld">
                             <span class="menu-icon"><i class="bi bi-folder"></i></span>
                            <span class="menu-txt">Repository</span>
                          </div>
                       </a>
                </li>
                 -->
        <li class="menu-item" routerLink="/main/contracts/training" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon">
                <img class="active" src="../../../assets/images/brain-circuit-active.svg" height="35" width="35">
                <img class="inactive" src="../../../assets/images/brain-circuit-inactive.svg" height="35" width="35">
              </span>
              <span class="menu-txt">AI Training</span>
            </div>
          </a>
        </li>
        <li class="menu-item" routerLink="/main/contracts/global-search" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="bi bi-globe"></i></span>
              <span class="menu-txt"> Global Q&A</span>
            </div>
          </a>
        </li>
        <li class="menu-item" routerLink="/main/contracts/feedback" routerLinkActive="active"
          *ngIf="userDetails?.role === 102">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="bi bi-chat-right-text"></i></span>
              <span class="menu-txt">Feedback</span>
            </div>
          </a>
        </li>


        <li class="menu-item" routerLink="/main/contracts/config" routerLinkActive="active">

          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-gears "></i></span>
              <span class="menu-txt">Configuration</span>
            </div>
          </a>

        </li>

        }
        @if(selectedApps=='rfpcontract'){
        <!-- <li class="menu-item" routerLink="/main/rfpcontracts/reports" routerLinkActive="active" *ngIf="userDetails?.role === 102">
                       <a  class="menu-a" >
                          <div class="menu-txt-hld">
                           <span class="menu-icon">   <i class="bi bi-bar-chart-line-fill"></i></span>
                            <span class="menu-txt">Report dashboard</span>
                          </div>
                       </a>
                </li>  -->

        <li class="menu-item" routerLink="/main/rfpcontracts/rfptraining" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon">
                <img class="active" src="../../../assets/images/brain-circuit-active.svg" height="35" width="35">
                <img class="inactive" src="../../../assets/images/brain-circuit-inactive.svg" height="35" width="35">
              </span>
              <span class="menu-txt">AI Training</span>
            </div>
          </a>
        </li>
        <li class="menu-item" routerLink="/main/rfpcontracts/createContract" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="bi bi-card-text"></i></span>
              <span class="menu-txt">Create</span>
            </div>
          </a>
        </li>

        <li class="menu-item" routerLink="/main/rfpcontracts/repository" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="bi bi-folder"></i></span>
              <span class="menu-txt">Repository</span>
            </div>
          </a>
        </li>
        <li class="menu-item" routerLink="/main/rfpcontracts/global-search" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="bi bi-globe"></i></span>
              <span class="menu-txt"> Global Q&A</span>
            </div>
          </a>
        </li>
        <!--   <li class="menu-item" routerLink="/main/rfpcontracts/negotiation" routerLinkActive="active" *ngIf="userDetails?.role === 102">
                       <a  class="menu-a" >
                          <div class="menu-txt-hld">
                            <span class="menu-icon"><i class="bi bi-envelope"></i></span> 
                            <span class="menu-txt">Discussion</span>
                          </div>
                       </a>
                </li>
         -->
        <li class="menu-item" routerLink="/main/rfpcontracts/feedback" routerLinkActive="active"
          *ngIf="userDetails?.role === 102">

          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="bi bi-chat-right-text"></i></span>
              <span class="menu-txt">Feedback</span>
            </div>
          </a>

        </li>
        <!-- <li class="menu-item" routerLink="/main/rfpcontracts/execution" routerLinkActive="active" *ngIf="userDetails?.role === 102">
                   
                         <a  class="menu-a" >
                          <div class="menu-txt-hld">
                            <span class="menu-icon"><i class="bi bi-filetype-exe"></i></span>
                            <span class="menu-txt">Excel Q & A</span>
                          </div>
                       </a>
                      
                </li>-->
        <li class="menu-item" routerLink="/main/rfpcontracts/config" routerLinkActive="active"
          *ngIf="userDetails?.role === 102">

          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-gears "></i></span>
              <span class="menu-txt">Configuration</span>
            </div>
          </a>

        </li>

        }
        @if(selectedApps=='infosecurity'){
        <!-- <li class="menu-item" routerLink="/main/infosecurity/reports" routerLinkActive="active" *ngIf="userDetails?.role === 102">
                       <a  class="menu-a" >
                          <div class="menu-txt-hld">
                           <span class="menu-icon">   <i class="bi bi-bar-chart-line-fill"></i></span>
                            <span class="menu-txt">Report dashboard</span>
                          </div>
                       </a>
                </li>  -->

        <li class="menu-item" routerLink="/main/infosecurity/training" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon">
                <img class="active" src="../../../assets/images/brain-circuit-active.svg" height="35" width="35">
                <img class="inactive" src="../../../assets/images/brain-circuit-inactive.svg" height="35" width="35">
              </span>
              <span class="menu-txt">AI Training</span>
            </div>
          </a>
        </li>
        <li class="menu-item" routerLink="/main/infosecurity/createContract" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="bi bi-card-text"></i></span>
              <span class="menu-txt">Create</span>
            </div>
          </a>
        </li>

        <li class="menu-item" routerLink="/main/infosecurity/repository" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="bi bi-folder"></i></span>
              <span class="menu-txt"> Repository</span>
            </div>
          </a>
        </li>
        <li class="menu-item" routerLink="/main/infosecurity/global-search" routerLinkActive="active">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="bi bi-globe"></i></span>
              <span class="menu-txt"> Global Q&A</span>
            </div>
          </a>
        </li>
        <!--  <li class="menu-item" routerLink="/main/infosecurity/negotiation" routerLinkActive="active" *ngIf="userDetails?.role === 102">
                       <a  class="menu-a" >
                          <div class="menu-txt-hld">
                            <span class="menu-icon"><i class="bi bi-envelope"></i></span> 
                            <span class="menu-txt">Discussion</span>
                          </div>
                       </a>
                </li>-->

        <li class="menu-item" routerLink="/main/infosecurity/feedback" routerLinkActive="active"
          *ngIf="userDetails?.role === 102">

          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="bi bi-chat-right-text"></i></span>
              <span class="menu-txt">Feedback</span>
            </div>
          </a>

        </li>
        <!-- <li class="menu-item" routerLink="/main/rfpcontracts/execution" routerLinkActive="active" *ngIf="userDetails?.role === 102">
                   
                         <a  class="menu-a" >
                          <div class="menu-txt-hld">
                            <span class="menu-icon"><i class="bi bi-filetype-exe"></i></span>
                            <span class="menu-txt">Excel Q & A</span>
                          </div>
                       </a>
                      
                </li>-->
        <li class="menu-item" routerLink="/main/infosecurity/config" routerLinkActive="active">

          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-gears "></i></span>
              <span class="menu-txt">Configuration</span>
            </div>
          </a>

        </li>

        }
        @if(selectedApps=='contract'){
        <li class="menu-item" routerLink="/main/contracts/contract-filter" routerLinkActive="active"
          *ngIf="userDetails?.role === 102">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"> <i class="bi bi-file-earmark-check"></i></span>
              <span class="menu-txt">Contract Status</span>
            </div>
          </a>
        </li>

        <li class="menu-item" routerLink="/main/contracts/inbox" routerLinkActive="active"
          *ngIf="userDetails?.role === 102 && false">
          <a class="menu-a">
            <div class="menu-txt-hld">
              <span class="menu-icon"> <i class="bi bi-inbox"></i></span>
              <span class="menu-txt">Inbox</span>
            </div>
          </a>
        </li>
        }
        <!-- <li class="menu-item"  routerLink="/main/configuration" routerLinkActive="active" *ngIf="userDetails?.role === 102">
                    <a  class="menu-a" >
            <div class="menu-txt-hld">
              <span class="menu-icon"><i class="fa-solid fa-gears "></i></span>
              <span class="menu-txt">Configuration</span>
            </div>
          </a>
         </li> -->
      </ul>
    </nav>


    <!-- <nav class="navbar sdBr" [ngClass]="{'sdBrExp':!sideExp}">
        <div class="menubar-icon">
             <li class="nav-item">
                 <a   class="nav-link">
                    <span class="icon" (click)="expandCollaspse()">
                        <i class="pi pi-bars"></i>
                    </span>
                    <span class="menu-text"></span>
                    </a>
              </li>
           
        </div>
        <div class="forUList" id="myScrollbar">
               
            <ul class="nav secondUl">
                
                      @if(selectedApps=='audio'){
                         
                             <li class="nav-item">
                                <a href="" class="nav-link" 
                                    routerLink="/main/fileUpload" routerLinkActive="active" tooltip="File Upload" [options]="myOptions">
                                  <span class="icon"> <i class="fa-solid fa-cloud-arrow-up navIcons"></i></span> 
                                    <span class="menu-text">File Upload</span>
                                </a>
                            </li>
                            <li class="nav-item">
                    <a href="" class="nav-link" 
                        routerLink="/main/progress" routerLinkActive="active" tooltip="Progress Monitor"
                        [options]="myOptions">
                      <span class="icon">  <i class="fa fa-tasks "></i></span>
                        <span class="menu-text">Progress Monitor</span>
                    </a>
                </li>
                <li class="nav-item">
                    <a href="" class="nav-link" 
                        routerLink="/main/audioRecords" routerLinkActive="active" tooltip="Voice Analytics"
                        [options]="myOptions">
                      <span class="icon"> <i class="fa fa-file-audio "></i></span> 
                        <span class="menu-text">Voice Analytics</span>
                    </a>
                </li>
            }
                       
                              @if(selectedApps=='email'){
                         <li class="nav-item">
                                <a href="" class="nav-link" 
                                    routerLink="/main/emailfileUpload" routerLinkActive="active" tooltip="File Upload" [options]="myOptions">
                                   <span class="icon"> <i class="fa-solid fa-cloud-arrow-up "></i></span>
                                    <span class="menu-text">File Upload</span>
                                </a>
                            </li>
                            <li class="nav-item">
                            <a href="" class="nav-link" routerLink="/main/autoEmailRecords" routerLinkActive="active"
                                tooltip="Email Analytics" [options]="myOptions">
                              <span class="icon"> <i class="fa-solid  fa-envelope "></i></span> 
                                <span class="menu-text">Email Analytics</span>
                            </a>
                            </li>
                        }

                        @if(selectedApps=='voiceMail'){
                              <li class="nav-item">
                                <a href="" class="nav-link" 
                                    routerLink="/main/voiceemailfileUpload" routerLinkActive="active" tooltip="File Upload" [options]="myOptions">
                                  <span class="icon"> <i class="fa-solid fa-cloud-arrow-up "></i></span> 
                                    <span class="menu-text">File Upload</span>
                                </a>
                            </li>
                            <li class="nav-item">
                    <a href="" class="nav-link" 
                        routerLink="/main/progress" routerLinkActive="active" tooltip="Progress Monitor"
                        [options]="myOptions">
                       <span class="icon"> <i class="fa fa-tasks "></i></span>
                        <span class="menu-text">Progress Monitor</span>
                    </a>
                </li>
                            <li class="nav-item">
                            <a href="" class="nav-link" routerLink="/main/voiceMailRecords" routerLinkActive="active"
                                tooltip="Voice Email Analytics" [options]="myOptions">
                              <span class="icon"> <i class="fa-solid fa-voicemail "></i></span> 
                                <span class="menu-text">Voice Mail Analytics</span>
                            </a>
                            </li>
                        }
                        
                         @if(selectedApps=='survey'){
                             <li class="nav-item">
                                <a href="" class="nav-link"  routerLink="/main/surveyRecords" routerLinkActive="active"
                                    tooltip="Survey Analytics" [options]="myOptions">
                                   <span class="icon"><i class="fa-solid fa-square-check "></i></span> 
                                    <span class="menu-text">Survey Analytics</span>
                                </a>
                                </li>
                         }@else if(selectedApps=='ivr'){

                             <li class="nav-item">
                                <a href="" class="nav-link" 
                                    routerLink="/main/fileUpload" routerLinkActive="active" tooltip="File Upload" [options]="myOptions">
                                   <span class="icon"> <i class="fa-solid fa-cloud-arrow-up "></i></span>
                                    <span class="menu-text">File Upload</span>
                                </a>
                            </li>
                            <li class="nav-item">
                    <a href="" class="nav-link" 
                        routerLink="/main/progress" routerLinkActive="active" tooltip="Progress Monitor"
                        [options]="myOptions">
                      <span class="icon"> <i class="fa fa-tasks "></i></span> 
                        <span class="menu-text">Progress Monitor</span>
                    </a>
                </li>
                             <li class="nav-item">
                                <a href="" class="nav-link"  routerLink="/main/ivrRecords" routerLinkActive="active"
                                    tooltip="Survey Analytics" [options]="myOptions">
                                  <span class="icon"> <i class="fa-solid fa-square-check "></i></span> 
                                    <span class="menu-text">IVR Analytics</span>
                                </a>
                                </li>
                         }@else if(selectedApps=='text'){
                              <li class="nav-item">
                                <a href="" class="nav-link" 
                                    routerLink="/main/textfileUpload" routerLinkActive="active" tooltip="File Upload" [options]="myOptions">
                                   <span class="icon"><i class="fa-solid fa-cloud-arrow-up "></i></span> 
                                    <span class="menu-text">File Upload</span>
                                </a>
                            </li>
                             <li class="nav-item">
                            <a href="" class="nav-link" routerLink="/main/textRecords" routerLinkActive="active"
                                tooltip="Email Analytics" [options]="myOptions">
                               <span class="icon"><i class="fa-solid fa-file-lines "></i></span> 
                                <span class="menu-text">Text Analytics</span>
                            </a>
                            </li>
                         }
                         
                             

                         
                        
                          <li class="nav-item" *ngIf="userDetails?.role === 102">
                    <a href="" class="nav-link" 
                        routerLink="/main/userManagement" routerLinkActive="active" tooltip="User Management"
                        [options]="myOptions">
                       <span class="icon"><i class="fa fa-users "></i></span>
                        <span class="menu-text">User Management</span>
                    </a>
                </li>

                  @if(selectedApps=='email'){
                     <li class="nav-item" *ngIf="userDetails?.role === 102">
                    <a href="" class="nav-link"
                        routerLink="/main/emailconfiguration" routerLinkActive="active" tooltip="Configuration"
                        [options]="myOptions">
                       <span class="icon"> <i class="fa-solid fa-gears "></i></span>
                        <span class="menu-text">Configuration</span>
                    </a>
                </li>
                  }@else{
                 <li class="nav-item" *ngIf="userDetails?.role === 102">
                    <a href="" class="nav-link"
                        routerLink="/main/configuration" routerLinkActive="active" tooltip="Configuration"
                        [options]="myOptions">
                       <span class="icon"> <i class="fa-solid fa-gears "></i></span>
                        <span class="menu-text">Configuration</span>
                    </a>
                </li>
              }
         
               
                
               
            
             
               
              
             
               
               

            </ul>
              
        </div>
        
   
     </nav> -->
    <div class="forUList" id="profile-setting">
      <li class="menu-item">
        <a class="menu-a">
          <div class="menu-txt-hld">
            <span class="menu-icon">

              <img *ngIf="profile" [src]="userimage" width="36" height="36">

              <ng-container *ngIf="!profile"> <i class="fa fa-user"></i></ng-container>



            </span>
            <ng-container *ngIf="sideExp">
              <span class="menu-txt">{{userDetails?.name}}</span>
            </ng-container>
            <ng-container *ngIf="!sideExp">
              <span class="menu-txt">{{userDetails?.name}}</span>
            </ng-container>

          </div>
        </a>
      </li>
      <li class="menu-item" routerLink="/main/settings" routerLinkActive="active">
        <a class="menu-a">
          <div class="menu-txt-hld">
            <span class="menu-icon"><i class="fa fa-cog"></i></span>
            <span class="menu-txt">Settings</span>
          </div>
        </a>
      </li>

      <li class="menu-item" (click)="clearStorage()">
        <a class="menu-a">
          <div class="menu-txt-hld">
            <span class="menu-icon"><i class="fa fa-sign-out" style="transform: rotate(180deg);"></i></span>
            <span class="menu-txt">Logout</span>
          </div>
        </a>
      </li>

      <!-- <ul class="nav firstUl">
               <li class="nav-item userNavItem">
                     <a class="nav-link">
                        <div class="file-tab">
                            <img id="profile-picture" class="profile-picture-class" *ngIf="profile" [src]="userimage"
                                alt="Profile image" id="" name="" tooltip="{{userDetails?.name}}" [options]="myOptions" />
                            <b *ngIf="!profile" class="userFont" tooltip="{{userDetails?.name}}"
                                [options]="myOptions">{{ userDetails?.name.toUpperCase() | slice:0:1}}</b>
                        </div>
                        <p class="userName" *ngIf="!sideExp"> {{userDetails?.name}}</p>
                    </a> 
                    <i class="fa fa-angle-double-down userDrop" (click)="showHideDropDown('up')"
                        *ngIf="DropDownArrow === 'down' " aria-hidden="true" data-bs-toggle="collapse"
                        data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"></i>
                    <i class="fa fa-angle-double-up userDrop" (click)="showHideDropDown('down')"
                        *ngIf="DropDownArrow === 'up' " aria-hidden="true" data-bs-toggle="collapse"
                        data-bs-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample"></i> 
                    <div class="collapse show userCollapse" id="collapseExample">
                        <div class="card card-body userDropdownCard">
                            <a class="userDropdownMenu nav-link scale-class" [tooltip]="userDetails?.email"
                                [options]="myOptions"> <i class="fa fa-user nav-icons-dropdown" aria-hidden="true"></i>
                                <span class="userDropdownMenuText" [tooltip]="userDetails?.email"
                                    [options]="myOptions2" *ngIf="!sideExp"> {{userDetails?.email}} </span></a>
                            <a  class="userDropdownMenu nav-link scale-class" routerLink="/main/settings"
                                routerLinkActive="active" tooltip="Settings" [options]="myOptions"> <i
                                    class="fa fa-cog nav-icons-dropdown" aria-hidden="true"></i>
                                <span class="userDropdownMenuText" *ngIf="!sideExp"> Settings</span></a>
                            <a class="userDropdownMenu nav-link scale-class" (click)="clearStorage()"
                                tooltip="Logout" [options]="myOptions"> <i class="fa fa-sign-out nav-icons-dropdown"
                                    aria-hidden="true" style="transform: rotate(180deg);"></i><span class="userDropdownMenuText" *ngIf="!sideExp">
                                    Logout</span></a>
                        </div>
                    </div>
                </li> 
            </ul> -->

    </div>
  </div>
</div>